<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
    <van-notice-bar 
  text="暂时不支持俱乐部升级申报"
  /> 
         <!-- <van-notice-bar 
  text="第五届文化纪俱乐部升级已经截止 可选择其他线下活动到场领取"
/>  -->
      <!-- </van-cell-group> -->
      <!-- <van-notice-bar 
  text="俱乐部牌匾授牌仪式，仅限俱乐部赛及六大赛可参与领取"
/> -->
    <van-form
      v-show="false"
        @submit="onSubmit"
        @failed="onFailed"
        v-if="!showInfo"
    >
      <van-cell-group> 
          <van-field
              readonly
              clickable 
              v-show="formData.jindu!=6"
              :value="formData.extra_saiqu2.length ? formData.extra_saiqu2[0].name : ''"
              autosize
              type="textarea"
              input-align="right"
              label="可申请升级赛区"
              placeholder="点击选择已报名参赛的赛区"
              @click="showSaiquPicker2 = true"
          />
          <SaiquPicker
              :show="showSaiquPicker2"
              url="api/sai/clubHeightSaiquOptions"
              :limit="1"
              :is_online="2"
              :value="formData.extra_saiqu2"
              @onChange="onSaiqu2Change"
              @onClose="showSaiquPicker2=false"
              :defaultValue="formData.extra_saiqu2"
              @onConfirm="onSaiqu2Confirm"
          ></SaiquPicker>
          <van-field
              readonly
              clickable 
              v-show="formData.jindu!=6"
              :value="formData.extra_saiqu.length ? formData.extra_saiqu[0].name : ''"
              autosize
              type="textarea"
              input-align="right"
              label="选择授牌领取的比赛名称"
              placeholder="点击选择领取的比赛名称"
              @click="showSaiquPicker = true"
          />
          <SaiquPicker
              :show="showSaiquPicker"
              url="api/sai/clubGradeSaiquOptions"
              :limit="1"
              :is_online="2"
              :value="formData.extra_saiqu"
              @onChange="onSaiquChange"
              @onClose="showSaiquPicker=false"
              :defaultValue="formData.extra_saiqu"
              @onConfirm="onSaiquConfirm"
          ></SaiquPicker>
          
        <van-field
            readonly
            clickable
            name="area"
            :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
            input-align="right"
            label="地区选择"
            placeholder="点击选择省市区"
            @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>

        <van-field
            v-model="formData.danwei"
            :rules="[{ required: true, message: '不能为空' }]"
            label="俱乐部名称"
            input-align="right"
            error-message-align="right"
            clearable
            placeholder="请输入俱乐部名称"
        />
        <!--            <van-field name="radio" label="类型"-->
        <!--                       input-align="right">-->
        <!--                <template #input>-->
        <!--                    <van-radio-group v-model="formData.clubleixing" direction="horizontal">-->
        <!--                        <van-radio checked-color="#ffb01b" name="社会俱乐部">社会俱乐部</van-radio>-->
        <!--                        <van-radio checked-color="#ffb01b" name="学校俱乐部">学校俱乐部</van-radio>-->
        <!--                    </van-radio-group>-->
        <!--                </template>-->
        <!--            </van-field>-->
        <van-field name="radio" label="申报等级"
                   input-align="right">
          <template #input>
            <span v-show="formData.grade=='二星'">暂无升级方案</span>
            <van-radio-group v-model="formData.bgrade">
              <!--                        <van-radio checked-color="#ffb01b" name="一星">一星</van-radio>-->
              <van-radio checked-color="#ffb01b" name="二星" v-show="formData.grade=='一星'">二星</van-radio>
              <van-radio checked-color="#ffb01b" name="三星" v-show="formData.grade=='三星'">三星</van-radio>
              <van-radio checked-color="#ffb01b" name="四星" v-show="formData.grade=='四星'">四星</van-radio>
              <van-radio checked-color="#ffb01b" name="五星" v-show="formData.grade=='五星'">五星</van-radio>
            </van-radio-group>
          </template>
        </van-field>
         <van-notice-bar 
  text="申报二星级俱乐部需有至少一次参赛经历哦"
/>


      </van-cell-group>

    <div style="margin-top: 30px; text-align: center"> 

      <van-button 
          style="margin: 0 auto"
          size="normal" round @click="goWenjuan()">俱乐部情况调查问卷
      </van-button>
    </div> 

      <div class="savebtn">
        <van-button
            v-show="formData.jindu==6"
            :disabled="true"
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round    >
          已授牌
        </van-button>
        <van-button
            v-show="formData.jindu!=6 && formData.grade!='二星'"
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
          提交申请
        </van-button>
      </div>
    </van-form>


    <div v-else v-show="false">
      <div style="padding: 0 .2rem">
        <ul class="step-two-box">
          <li>提交申报信息成功！</li>
          <li>工作人员会在三个工作日内与您联系。</li>
          <li>审批通过后，点击 “刷新”按钮，方可</li>
          <li>进行下一步操作</li>
        </ul>
      </div>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round >
          刷新
        </van-button>
      </div>
    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}
step-two-box {
  padding: .4rem .2rem;
  font-size: 16px;
}

.step-two-box li {
  margin-bottom: .3rem;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import SaiquPicker from '@/components/picker/SaiquPicker.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubApply',
  components: {
    PicUploader,
    SaiquPicker,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      showArea: false,
      showSaiquPicker: false,
      showSaiquPicker2: false,
      showInfo: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        areas: '',
        province: '',
        extra_saiqu: [],
        extra_saiqu2: [],
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
//                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        changdipic: [],
        shenbaozip: [],
//                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        zhizhaopic: [],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = "升级星级俱乐部"
//            if(that.formData.id){
    this.fetch();
//            }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    goWenjuan(){
        appEvent({
          name: "downloadFile",
          query: { url: 'https://qywx.wjx.cn/vm/OyTKhQN.aspx' },
        });
    },
    onSaiquChange(values) {
      console.log('onSaiquChange', values)
      this.formData.extra_saiqu = [...values];
    },
    onSaiquConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker = false;
      this.formData.extra_saiqu = [...values];
    },
    onSaiqu2Change(values) {
      console.log('onSaiquChange', values)
      this.formData.extra_saiqu2 = [...values];
    },
    onSaiqu2Confirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker2 = false;
      this.formData.extra_saiqu2 = [...values];
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      // return
      for (let field in that.formData) {

        // if (that.formData.changdipic.length != 5) {
        //     Toast('请上传5张场地照片');
        //     return
        // }
        // if (that.formData.shenbaozip.length == 0) {
          // Toast('请上传申报表');
          // return
        // }
        if (!that.formData.bgrade || that.formData.bgrade == '一星') {
          Toast('请选择等级');
          return
        }
        // if (!that.formData.clubleixing ) {
        //     Toast('请选择俱乐部类型');
        //     return
        // }
        // if (!this.formData.area) {
        //     Toast('请选择地区');
        //     return
        // }
      }

      that.formData.stationid = that.formData.extra_saiqu.length ? that.formData.extra_saiqu[0].id :0
      if(!that.formData.stationid){
          // Toast('请选择授牌赛区');
          // return ;
      }
      that.formData.stationid2 = that.formData.extra_saiqu2.length ? that.formData.extra_saiqu2[0].id :0
      if(!that.formData.stationid2){
          Toast('请选择升级赛区');
          return ;
      }
      that.saveLoading = true;


      that.$api.post('/api/club/gradeApply', that.formData, (res) => {
        that.saveLoading = false;
       that.showInfo = true
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/club/gradeApplyDetail', {
        id: that.formData.id
      }, (res) => {
        that.formData = res.data;
        that.formData.grade = that.formData.bgrade
        that.formData.bgrade = ''
        if (res.data.kaojiregist_status == 1 || res.data.kaojiregist_status == 2) {
          rbLink({
            name: "ClubResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        }
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// ClubHighApply.vue?497f22ce